// src/components/Phaser/help/HelpPanel.tsx
import React, { useState } from 'react';
import { Button, Col, Row } from 'antd';
import {
    AppstoreOutlined,
    UserOutlined,
    InboxOutlined,
    SoundOutlined,
} from '@ant-design/icons';

import { TSprite } from '../../../../models/objects/sprite';
import { TObstacle, TScene } from '../../../../models/objects/objects';
import { TSound } from '../../../../models/objects/media';

// Types IDE (pour le langage courant) 

import SceneHelp from './SceneHelp';
import CharacterHelp from './CharacterHelp';
import ObjectHelp from './ObjectHelp';
import SoundHelp from './SoundHelp';
import { LanguageId } from '../core/types';

interface HelpPanelProps {
    sprites: TSprite[];
    scenesConfig: TScene[];
    obstacles: TObstacle[];
    sounds: TSound[];
    language?: LanguageId; // 'javascript' | 'python'
}

const HelpPanel: React.FC<HelpPanelProps> = ({
    sprites,
    scenesConfig,
    obstacles,
    sounds,
    language = 'javascript',
}) => {
    const [openModal, setOpenModal] = useState<string | null>(null);

    const handleOpen = (modalType: string) => () => setOpenModal(modalType);
    const handleClose = () => setOpenModal(null);

    return (
        <div>
            <Row gutter={[8, 8]} justify="end">
                <Col>
                    <Button
                        icon={<AppstoreOutlined />}
                        onClick={handleOpen('scene')}
                        className="white-outline-button"
                    >
                        Scènes
                    </Button>
                </Col>
                <Col>
                    <Button
                        icon={<UserOutlined />}
                        onClick={handleOpen('character')}
                        className="white-outline-button"
                    >
                        Personnages
                    </Button>
                </Col>
                <Col>
                    <Button
                        icon={<InboxOutlined />}
                        onClick={handleOpen('object')}
                        className="white-outline-button"
                    >
                        Objets
                    </Button>
                </Col>
                <Col>
                    <Button
                        icon={<SoundOutlined />}
                        onClick={handleOpen('sound')}
                        className="white-outline-button"
                    >
                        Sons
                    </Button>
                </Col>
            </Row>

            {/* Popups (bilingues) */}
            <SceneHelp
                open={openModal === 'scene'}
                onClose={handleClose}
                scenesConfig={scenesConfig}
            />
            <CharacterHelp
                open={openModal === 'character'}
                onClose={handleClose}
                sprites={sprites}
                language={language}
            />
            <ObjectHelp
                open={openModal === 'object'}
                onClose={handleClose}
                obstacles={obstacles}
                language={language}
            />
            <SoundHelp
                open={openModal === 'sound'}
                onClose={handleClose}
                sounds={sounds}
                language={language}
            />
        </div>
    );
};

export default HelpPanel;
